import { Component } from '@theme/component';

/**
 * Brand mark that blooms in once when it scrolls into view. While hovered or keyboard-focused it
 * turns into the wordmark, and turns straight back when the pointer or focus leaves.
 *
 * @extends {Component}
 */
class BrandMark extends Component {
  /** @type {IntersectionObserver | undefined} */
  #observer;

  connectedCallback() {
    super.connectedCallback();

    // Only hide the mark for the reveal once this script is running, so it never stays hidden.
    this.setAttribute('data-ready', '');

    if (!('IntersectionObserver' in window)) {
      this.setAttribute('data-revealed', '');
      return;
    }

    this.#observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.setAttribute('data-revealed', '');
        this.#observer?.disconnect();
      },
      { threshold: 0.6 }
    );
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
    this.dataset.state = 'mark';
  }

  /**
   * Shows the wordmark. Touch taps follow the link instead.
   * @param {PointerEvent | FocusEvent} [event]
   */
  show = (event) => {
    if (event instanceof PointerEvent && event.pointerType !== 'mouse') return;
    if (event instanceof FocusEvent && !this.querySelector(':focus-visible')) return;
    this.dataset.state = 'word';
  };

  /** Turns the wordmark back into the mark. */
  hide = () => {
    this.dataset.state = 'mark';
  };
}

if (!customElements.get('brand-mark')) {
  customElements.define('brand-mark', BrandMark);
}
